import React from 'react';
import { EntitiesLayout } from './entities.layout';
import { PagePath } from '../../../navigation/navigation.enums';

export function TeamEntitiesPage(): JSX.Element {
  return <EntitiesLayout path={PagePath.analyticsTeams} type="teams" />;
}